module.exports = "/images/frau-1.jpg?950c930c829c15180230b938da299436";